/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsModeratorControllerFindProductToModerateByIdQueryResponse,
  TelegramProductsModeratorControllerFindProductToModerateByIdPathParams,
  TelegramProductsModeratorControllerFindProductToModerateById401,
  TelegramProductsModeratorControllerFindProductToModerateById404,
} from '../../types/TelegramProductsModeratorControllerFindProductToModerateById.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramProductsModeratorFindProductToModerateById } from '../../methods/telegramProductsModeratorFindProductToModerateById.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramProductsModeratorFindProductToModerateByIdQueryKey = (
  id: TelegramProductsModeratorControllerFindProductToModerateByIdPathParams['id'],
) => [{ url: '/api/moderator/telegram/products/:id', params: { id: id } }] as const;

export type TelegramProductsModeratorFindProductToModerateByIdQueryKey = ReturnType<
  typeof telegramProductsModeratorFindProductToModerateByIdQueryKey
>;

export function telegramProductsModeratorFindProductToModerateByIdQueryOptions(
  id: TelegramProductsModeratorControllerFindProductToModerateByIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramProductsModeratorFindProductToModerateByIdQueryKey(id);
  return queryOptions<
    TelegramProductsModeratorControllerFindProductToModerateByIdQueryResponse,
    ResponseErrorConfig<
      | TelegramProductsModeratorControllerFindProductToModerateById401
      | TelegramProductsModeratorControllerFindProductToModerateById404
    >,
    TelegramProductsModeratorControllerFindProductToModerateByIdQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramProductsModeratorFindProductToModerateById(id, config);
    },
  });
}

/**
 * {@link /api/moderator/telegram/products/:id}
 */
export function useTelegramProductsModeratorFindProductToModerateById<
  TData = TelegramProductsModeratorControllerFindProductToModerateByIdQueryResponse,
  TQueryData = TelegramProductsModeratorControllerFindProductToModerateByIdQueryResponse,
  TQueryKey extends QueryKey = TelegramProductsModeratorFindProductToModerateByIdQueryKey,
>(
  id: TelegramProductsModeratorControllerFindProductToModerateByIdPathParams['id'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramProductsModeratorControllerFindProductToModerateByIdQueryResponse,
        ResponseErrorConfig<
          | TelegramProductsModeratorControllerFindProductToModerateById401
          | TelegramProductsModeratorControllerFindProductToModerateById404
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramProductsModeratorFindProductToModerateByIdQueryKey(id);

  const query = useQuery(
    {
      ...telegramProductsModeratorFindProductToModerateByIdQueryOptions(id, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | TelegramProductsModeratorControllerFindProductToModerateById401
      | TelegramProductsModeratorControllerFindProductToModerateById404
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
